import getField from '@form/formGenerator'

export const billingTypeSaveUrl = `${import.meta.env.VITE_API_URL}/api/billing-types`

export const billingTypeFormObject = {
  id: null,
  name: null
}

export const billingTypeFormFields = (billingTypeFormObject, updateFormObject, saveForm, errors, isLoading, t) => {
  const fields = [
    {
      type: 'text',
      name: 'name',
      label: t('labels.name'),
      value: billingTypeFormObject.name,
      key: 'billingTypeFormObject-name',
      cssClass: 'column is-12'
    },
    {
      type: 'switcher',
      name: 'isSurfaceBased',
      label: t('labels.is_surface_based'),
      value: billingTypeFormObject.isSurfaceBased,
      cssClass: 'column is-12',
      key: 'billingTypeFormObject-isSurfaceBased',
      id: 'billingTypeFormObject-isSurfaceBased'
    }, {
      type: 'switcher',
      name: 'isUnitBased',
      label: t('labels.is_unit_based'),
      value: billingTypeFormObject.isUnitBased,
      cssClass: 'column is-12',
      key: 'billingTypeFormObject-isUnitBased',
      id: 'billingTypeFormObject-isUnitBased'
    },
    {
      type: 'button',
      buttons: true,
      callback: saveForm,
      cancel: false,
      validateText: t('actions.save'),
      cssClassParent: 'column is-12',
      cssClassValidate: 'button is-blue',
      validateIcon: 'icon-done',
      key: 'billingTypeFormObject-form',
      isLoading
    },
    {
      type: 'hidden',
      name: 'id',
      value: parseInt(billingTypeFormObject.id),
      key: 'billingTypeFormObject-id'
    }
  ]
  return fields.map(function (field) {
    return getField({ ...field, error: errors[field.name] ? errors[field.name].errors : '' }, updateFormObject)
  })
}